import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
const testimonials = [{
  name: 'Leeann Nickeas',
  experienceKey: 'testimonials.t1e',
  quoteKey: 'testimonials.t1q'
}, {
  name: 'Fabiana',
  experienceKey: 'testimonials.t2e',
  quoteKey: 'testimonials.t2q'
}, {
  name: 'Ayrton Ayala',
  experienceKey: 'testimonials.t3e',
  quoteKey: 'testimonials.t3q'
}, {
  name: 'Jesús Rodríguez',
  experienceKey: 'testimonials.t4e',
  quoteKey: 'testimonials.t4q'
}, {
  name: 'Lodovica Bruggi',
  experienceKey: 'testimonials.t5e',
  quoteKey: 'testimonials.t5q'
}];
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const id = setInterval(() => setIndex(i => (i + 1) % testimonials.length), 7000);
    return () => clearInterval(id);
  }, []);
  const next = () => setIndex(i => (i + 1) % testimonials.length);
  const prev = () => setIndex(i => (i - 1 + testimonials.length) % testimonials.length);
  return <section id="opiniones" className="py-16 sm:py-24 lg:py-32 px-5 sm:px-8 lg:px-24 bg-beige relative overflow-hidden w-full" data-id="element-259" data-mp="78tvh4cu4ryy">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 1.2,
      ease: [0.22, 1, 0.36, 1]
    }} className="text-center max-w-3xl mx-auto mb-12 sm:mb-16 lg:mb-20" data-id="element-260" data-mp="c8y3e5zogedk">
        <p className="uppercase tracking-[0.3em] text-olive text-[9px] sm:text-[10px] font-semibold mb-4 sm:mb-6" data-id="element-261" data-mp="1ivadfkhm6v1g">
          {t('testimonials.tag')}
        </p>
        <h2 className="font-display text-fluid-h2 text-volcanic font-light leading-[1.1]" data-id="element-262" data-mp="1nnlfasvx0qwn">
          {t('testimonials.title1')} <br data-id="element-263" data-mp="1xfwjesbi8wyd" />
          <span className="font-script text-fluid-script text-terracotta inline-block mt-[-0.1em]" data-id="element-264" data-mp="1siwewlub029d">
            {t('testimonials.title2')}
          </span>
        </h2>
      </motion.div>

      <div className="max-w-5xl mx-auto relative bg-ivory p-6 sm:p-12 md:p-16 lg:p-20 rounded-sm shadow-sm border border-sand mt-8 sm:mt-12" data-id="element-265" data-mp="1oj5hhza9unvv">
        <div className="absolute -top-6 sm:-top-8 left-1/2 -translate-x-1/2 text-6xl sm:text-8xl font-display text-terracotta leading-none opacity-20 select-none overflow-hidden h-12 sm:h-16" data-id="element-266" data-mp="1ejek9pubtus3">
          "
        </div>

        <div className="relative min-h-[320px] sm:min-h-[280px] md:min-h-[240px] flex flex-col justify-center" data-id="element-267" data-mp="14u4r06nqy62e">
          <AnimatePresence mode="wait" data-id="element-268" data-mp="10tkyjge4bqml">
            <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.8,
            ease: [0.22, 1, 0.36, 1]
          }} className="text-center px-2 sm:px-8 md:px-12 w-full" data-id="element-269" data-mp="vsdo19klcdc8">
              <div className="flex justify-center gap-1 sm:gap-1.5 mb-6 sm:mb-10 text-terracotta" data-id="element-270" data-mp="3gfnhfzhd9tzi">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} size={14} className="fill-current sm:w-4 sm:h-4" data-id="element-271" data-mp="2oopnks39k3cg" data-mpi={i} />)}
              </div>
              <p className="font-display italic text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-volcanic leading-snug mb-8 sm:mb-12 font-light" data-id="element-272" data-mp="2xiuo63878t56">
                "{t(testimonials[index].quoteKey)}"
              </p>
              <div className="flex flex-col items-center gap-1.5 sm:gap-2" data-id="element-273" data-mp="25075eugodq79">
                <p className="font-display text-xl sm:text-2xl text-volcanic" data-id="element-274" data-mp="1lw3t7tpbpth9">
                  {testimonials[index].name}
                </p>
                <p className="uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[9px] sm:text-[10px] text-volcanic/60 font-medium" data-id="element-275" data-mp="1gvpha0klpzdy">
                  {t(testimonials[index].experienceKey)}
                </p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Controls */}
        <div className="flex items-center justify-center gap-4 sm:gap-8 mt-8 sm:mt-12 md:mt-16" data-id="element-276" data-mp="1zobiz1i6wk6g">
          <button onClick={prev} aria-label="Testimonio anterior" className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-beige flex items-center justify-center text-volcanic hover:border-terracotta hover:text-terracotta transition-colors duration-300 flex-shrink-0" data-id="element-277" data-mp="2elke86am683g">
            <ChevronLeftIcon size={18} strokeWidth={1} className="sm:w-5 sm:h-5" data-id="element-278" data-mp="f8zxbw3lctga" />
          </button>
          <div className="flex gap-2 sm:gap-3" data-id="element-279" data-mp="2qxwjwffa7uce">
            {testimonials.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Testimonio ${i + 1}`} className={`h-[2px] transition-all duration-500 ${i === index ? 'w-8 sm:w-12 bg-terracotta' : 'w-4 sm:w-6 bg-beige hover:bg-terracotta/50'}`} data-id="element-280" data-mp="2vu3kdsowsdmy" data-mpi={i} />)}
          </div>
          <button onClick={next} aria-label="Siguiente testimonio" className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-beige flex items-center justify-center text-volcanic hover:border-terracotta hover:text-terracotta transition-colors duration-300 flex-shrink-0" data-id="element-281" data-mp="2c7f945grbs2u">
            <ChevronRightIcon size={18} strokeWidth={1} className="sm:w-5 sm:h-5" data-id="element-282" data-mp="3sm6zydy98ra1" />
          </button>
        </div>
      </div>
    </section>;
}